import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { Table, Button } from 'reactstrap'
import ScrollBar from 'react-perfect-scrollbar'
import * as CurrencyFormat from 'react-currency-format'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { RootState } from '../../../store/rootReducer'
import { Accident } from '../../../lib/interfaces/Accident.interface'

import FileList from 'src/common/FileList.component'
import Collapsible from '../../../common/Collapsible.component'

import * as accidentsActions from '../../../store/accidents/actions'

const moment = require('moment')

const get = require('lodash/get')
const map = require('lodash/map')
const compact = require('lodash/compact')
const isEmpty = require('lodash/isEmpty')

export interface CurrentAccidentProps {
  accident: Accident
  isFetchingFiles: boolean
  resetCurrentAccident: () => void
}

class CurrentAccident extends React.Component<CurrentAccidentProps> {
  constructor(props: CurrentAccidentProps) {
    super(props)

    this.handleEscapeKey = this.handleEscapeKey.bind(this)
  }

  componentDidMount() {
    document.addEventListener('keyup', this.handleEscapeKey)
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleEscapeKey)
  }

  get filesCollapsibleTitle() {
    const { accident } = this.props

    if (accident.files) {
      return `Files (${accident.files.length || 0})`
    }

    return 'Files'
  }

  handleEscapeKey(e) {
    if (e.keyCode === 27) {
      this.handleResetCurrentAccident(e)
    }
  }

  handleResetCurrentAccident = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    this.props.resetCurrentAccident()
  }

  renderLocation() {
    const { accident } = this.props

    return (
      <p className="mb-1">
        <b>Location: </b>
        {get(accident, 'locationPosition.location.code', '-')}
      </p>
    )
  }

  renderEmployee() {
    const { accident } = this.props

    const employeeNames = compact([ get(accident, 'employee.firstName'), get(accident, 'employee.lastName') ])

    if (employeeNames.length === 0) {
      return 'No name'
    }

    return employeeNames.join(' ')
  }

  render() {
    const { accident, isFetchingFiles } = this.props

    return (
      <div className="col-md-4 sidedetails" onKeyPress={e => console.log(e.keyCode)}>
        <div className="d-flex flex-column h-100 p-4">
          <div className="d-flex justify-content-between align-items-center">
            <h4>
              <CurrencyFormat
                prefix="$"
                decimalScale={2}
                displayType="text"
                value={accident.totalCost}
                fixedDecimalScale={true}
                thousandSeparator={true}
              />
            </h4>
            <a href="" className="sidedetails-close mx-2" onClick={this.handleResetCurrentAccident}>
              <FontAwesomeIcon icon={['fas', 'times-circle']} />
            </a>
          </div>
          <div className="mb-3">
            {this.renderLocation()}
            <p className="mb-1">
              <b>Date: </b>
              {moment(accident.lossDate).format('MM/DD/YYYY hh:mm A')}
            </p>
          </div>

          <ScrollBar className="flex-grow-1 min-height-0">
            <Collapsible noGutters defaultOpen icon={['fas', 'car']} title={`Claims (${accident.claims && accident.claims.length || 0})`}>
              <Table className="w-100">
                <tbody>
                  {map(accident.claims, claim => (
                    <tr key={claim.id}>
                      <td>
                        <div className="p-2">
                          <FontAwesomeIcon icon={['fas', 'car']} />
                          <span className="ml-2">{`${claim.vehicleMake} ${claim.vehicleModel}`}</span>
                        </div>
                        {claim.employee &&
                          <div className="p-2">
                            <FontAwesomeIcon icon={['fas', 'user']} />
                            <span className="ml-2">{this.renderEmployee()}</span>
                          </div>
                        }
                        <div className="p-2">
                          <FontAwesomeIcon icon={['fas', 'money-check']} />
                          <span className="ml-2">
                            <CurrencyFormat
                              prefix="$"
                              decimalScale={2}
                              displayType="text"
                              value={claim.damage}
                              fixedDecimalScale={true}
                              thousandSeparator={true}
                            />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Collapsible>

            <Collapsible defaultOpen title={this.filesCollapsibleTitle} icon={['far', 'save']} isLoading={isFetchingFiles}>
              {isFetchingFiles &&
                <span className="d-flex align-items-center justify-content-center">
                  <FontAwesomeIcon spin className="mr-2" icon={['fas', 'spinner']} />
                  Loading
                </span>
              }
              {!isFetchingFiles && (
                isEmpty(accident.files)
                  ? <span className="d-flex align-items-center justify-content-center">No files</span>
                  : (
                    <FileList
                      viewMode="card"
                      entity="accident"
                      files={accident.files}
                      entityId={accident.id}
                      fileWrapperClassName="list-group-item"
                      className="gglist list-group list-group-flush"
                    />
                  )
              )}
            </Collapsible>
          </ScrollBar>

          <Link to={`/accidents/${accident.id}`}>
            <Button color="primary" className="w-100 mt-1 py-2">
              Details page
            </Button>
          </Link>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  accident: state.accidents.currentAccident,
  isFetchingFiles: state.accidents.isFetchingFiles
})

const mapDispatchToProps = (dispatch) => ({
  resetCurrentAccident: () => dispatch(accidentsActions.setCurrentAccident(undefined))
})

export default connect(mapStateToProps, mapDispatchToProps)(CurrentAccident)



// WEBPACK FOOTER //
// ./src/routes/accidents/components/CurrentAccident.component.tsx